import { GET_ALL_GROUPS_SUCCESS } from '../actions/actionTypes';

export default function allGroups(state = [], action) {
  switch (action.type) {
    case GET_ALL_GROUPS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
